import { styled } from "styled-components";

import { ReactComponent as SoundEnabledIcon } from "../../assets/svg/scLogo.svg";
import { ReactComponent as SoundEnabledIcon2 } from "../../assets/svg/xLogo.svg";

const HomepageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-height: 100vh;
    background-color: #0e1015;
    color: #dddddd;
    font-family: "Arial", sans-serif;
    padding: 20px;
`;

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between; /* Space between left and right elements */
    align-items: center;
    width: 80%;
    padding: 10px 0;
    margin-top: 2rem;
`;

const SiteName = styled.h1`
    font-family: Khand;
    font-size: 1.5rem;
    color: #dddddd;
    margin: 0px;
`;

const SocialsContainer = styled.div`
    display: flex;
    gap: 15px;
    margin-right: 5rem;
`;

/* const SocialIcon = styled.a``; */

const SocialIcon = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;

    svg {
        width: 40px;
        height: 40px;
        fill: #dddddd;

        &:hover {
            fill: #c00808;
            color: #a80808;
        }
    }
`;

const Divider = styled.hr`
    width: 80%;
    border: 0;
    border-top: 1px solid #a92e4d;
    margin: 0px 0;
`;

const DemosContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Grid layout to start from the top left */
    gap: 20px;
    width: 80%;
    margin: 40px 0;
`;

const DemoItem = styled.a`
    font-family: Rubik;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    border-radius: 10px;

    color: #dddddd;

    &:hover {
        color: #a92e4d;
    }
`;

const DemoImage = styled.img`
    width: 100%;
    border-radius: 10px;
`;

const DemoText = styled.p`
    font-size: 1.2rem;
    margin-top: 10px;
    text-align: center;
`;

const Socials = () => {
    return (
        <SocialsContainer>
            <SocialIcon href="https://x.com/ohnoweknow" target="_blank" rel="noopener noreferrer">
                <SoundEnabledIcon2 />
            </SocialIcon>
            <SocialIcon href="https://soundcloud.com/sprawsmusic" target="_blank" rel="noopener noreferrer">
                <SoundEnabledIcon />
            </SocialIcon>
        </SocialsContainer>
    );
};

export const HomePage = () => {
    return (
        <HomepageContainer>
            {/* Header Section */}
            <HeaderContainer>
                <SiteName>internetNobody's Interactive Art</SiteName>
                <Socials></Socials>
            </HeaderContainer>

            {/* Divider */}
            <Divider />

            {/* Demos Section */}
            <DemosContainer>
                <DemoItem href="https://ohnoweknow.com/remedy" target="_blank" rel="noopener noreferrer">
                    <DemoImage src="remInt.webp" alt="Demo Image" />
                    <DemoText>Remedy Tribute</DemoText>
                </DemoItem>
            </DemosContainer>
        </HomepageContainer>
    );
};
